"use client"

import React from 'react'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { TransactionsSection } from './TransactionsSection'
import { BillingTransactionsSection } from './BillingTransactionsSection'
import { TimesheetsSection } from './TimesheetsSection'
import { EngagementAnalyticsSection } from './EngagementAnalyticsSection'
import { useFunctionalRoles } from '@/hooks/use-functional-roles'

const ENGAGEMENT_LEAD_ROLE_ID = 22

interface TransactionsContainerProps {
  engagementId?: number
}

export function TransactionsContainer({ engagementId }: TransactionsContainerProps) {
  const { isRestrictedAccess, loading: rolesLoading, error: rolesError } = useFunctionalRoles()
  const hideTransactions = rolesLoading || rolesError || isRestrictedAccess(ENGAGEMENT_LEAD_ROLE_ID)

  return (
    <Tabs defaultValue="analytics">
      <TabsList>
        <TabsTrigger value="analytics">Analytics</TabsTrigger>
        <TabsTrigger value="timesheets">Timesheets</TabsTrigger>
        {!hideTransactions && <TabsTrigger value="transactions">Transactions</TabsTrigger>}
        <TabsTrigger value="billing">Billing & Invoicing</TabsTrigger>
      </TabsList>
      <TabsContent value="analytics">
        <EngagementAnalyticsSection engagementId={engagementId} />
      </TabsContent>
      
      <TabsContent value="timesheets">
        <TimesheetsSection engagementId={engagementId} />
      </TabsContent>

      {!hideTransactions && (
        <TabsContent value="transactions">
          <TransactionsSection engagementId={engagementId} />
        </TabsContent>
      )}

      <TabsContent value="billing">
        <BillingTransactionsSection engagementId={engagementId} />
      </TabsContent>
    </Tabs>
  )
} 